export const text = {
  title: "Update Profile",
  fullName: "Full Name",
  fullNamePlaceholder: "Enter full name",
  displayName: "Display Name",
  displayNamePlaceholder: "Enter display name",
  basicInfo:
    "Basic info, like your name and address, that you use on Nio Platform.",
  basics: "Basics",
  email: "Email",
  socialLinks: "Social Links",
};
